var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4525 10.1317L10.3125 12.2717L9.00585 13.585C8.45252 14.1383 7.55252 14.1383 6.99918 13.585L3.54585 10.1317C3.09252 9.67833 3.41918 8.905 4.05252 8.905H11.9458C12.5858 8.905 12.9058 9.67833 12.4525 10.1317Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9458 6.78491H4.05251C3.41251 6.78491 3.09251 6.01158 3.54584 5.55825L6.99918 2.10491C7.55251 1.55158 8.45251 1.55158 9.00584 2.10491L12.4592 5.55825C12.9058 6.01158 12.5858 6.78491 11.9458 6.78491Z",
    fill: "#292D32",
    fillOpacity: 0.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.c0b4bba23541e8d7cf8d51255287b43c.svg";
export { ForwardRef as ReactComponent };